import { useTranslations } from 'next-intl'
import { useState, useEffect } from 'react'
import PdImage from '../pd-image/pd-image'
import AngleRight from '../pd-angle-right/pd-angle-right'

export interface GridBannerItem {
  title: string
  mediaUrl: string
  h5Src: string
  jumpUrl: string
  fontColor: string
  alt?: string
  altH5?: string
}

export interface PdGridBannerProps {
  data: GridBannerItem[]
}

function PdGridBanner({ data }: PdGridBannerProps) {
  const t = useTranslations()
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 1200)
    checkMobile()
    window.addEventListener('resize', checkMobile)
    return () => window.removeEventListener('resize', checkMobile)
  }, [])

  if (!data || data.length <= 0) {
    return null
  }

  return (
    <div className="w-full grid grid-cols-1 gap-4 laptop:grid-cols-2 laptop:gap-4">
      {data.map((item, index) => {
        // 如果 fontColor 为空或未定义，则使用 #ffffff
        const realFontColor = !item.fontColor ? '#ffffff' : item.fontColor

        return (
          <div
            key={`${item.title}-${index}`}
            className="relative w-full overflow-hidden "
            style={{ paddingBottom: isMobile ? '125%' : '64%' }} /* H5: 750:940, PC: 100:64 */
          >
            {/* 图片区域 - 绝对定位填满容器 */}
            <div className="absolute inset-0">
              <PdImage
                src={item.mediaUrl}
                h5Src={item.h5Src}
                width="100%"
                height="100%"
                object="cover"
                alt={(isMobile ? item.altH5 : item.alt) ?? item.title}
                enableMask={true}
                enableHoverScale={true}
                linkHref={item.jumpUrl}
                useLoader={true}
              />
            </div>
            {/* 文字叠加层 - 水平居中、使用百分比定位 */}
            <div
              className="absolute inset-x-0 flex flex-col items-center pointer-events-none px-4 gap-1 laptop:gap-2"
              style={{ top: '5%' }} /* 百分比上边距，随高度变化 */
            >
              <h3
                className="font-semibold text-center break-words max-w-[90%]"
                style={{ fontSize: 'clamp(18px, 3vw, 36px)', color: realFontColor }}
              >
                {item.title}
              </h3>
              {/* 了解更多 - 参考 BannerTop 的样式 */}
              <a
                href={item.jumpUrl}
                className="text-[0.6rem] laptop:text-sm flex items-center pointer-events-auto"
                style={{ color: realFontColor }}
              >
                {t('KnowMore')}
                <AngleRight
                  size="4x8"
                  customTheme={realFontColor}
                  className="w-[6px] h-[10px] laptop:w-[7px] laptop:h-[12px] ml-0.5 laptop:ml-1.5"
                />
              </a>
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default PdGridBanner
